import Crud from '../components/CookiesAccepted/Index'

let routes = {
    path: '/cookies_accepted',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/cookies_accepted',
            component: Crud
        },
    ]
};

export default routes;


// WEBPACK FOOTER //
// ./src/router/cookies_accepted.js